import { connect } from 'react-redux';

import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import Global from '../../../store/global-selectors';

import { SingleOutboundShipmentDisplay } from './index';

import { getShipmentInformation, buildShipmentInformation, getPackagingDetails } from './shipment-display-helper';

const mapStateToProps = (state, props) => {
  const { fulfillmentPlan, fulfillment, salesOrders } = getShipmentInformation(state, props);
  const shipment = buildShipmentInformation(state, fulfillmentPlan, fulfillment, salesOrders);
  const dimensionsUnit = Global.selectSellerDefaultDimensionUnit(state);
  const weightUnit = Global.selectSellerDefaultWeightUnit(state);
  const packagingDetails = getPackagingDetails(state, shipment, fulfillmentPlan, fulfillment, dimensionsUnit, weightUnit);
  const orderGridStatus = FulfillmentPlanOrderGridStatus[shipment?.orderGridStatus ?? ''];

  return {
    shipment,
    orderGridStatus,
    packagingDetails,
  };
};

export const SingleOutboundShipmentDisplayContainer = connect(mapStateToProps)(SingleOutboundShipmentDisplay);
